"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _character = _interopRequireDefault(require("./character"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: TODO: get correct guild object for mock
var guild = {
  id: 234234234,
  name: "DeJaVu",
  iconColor: "#DEDE32",
  cloakColor: "#6D1313",
  iconFileName: "guildmark_008.gif",
  guildmaster: _character.default,
  homeTown: {
    id: "ROG",
    i18nTag: {
      en: "ROG"
    },
    i18nDescription: {
      en: ""
    },
    position: {
      x: 0,
      y: 0,
      z: 0
    },
    territory: {},
    i18nName: {
      en: "Rog Imperium Castle"
    }
  },
  members: [],
  reputation: 234234234,
  rank: "Partial Lawfull"
};
var _default = guild;
exports.default = _default;